import React from 'react';
import AccountSidebar from '../components/AccountSidebar';
import CryptoWithdrawalsContent from '../components/CryptoWithdrawalsContent';

export default function CryptoWithdrawals() {
    return (
        <div className="account-layout acc-layout-mobile">
            <div className="container">
                <div className="account-wrapper">
                    <AccountSidebar activeItem="kripto-cekim" />
                    <CryptoWithdrawalsContent />
                </div>
            </div>
        </div>
    );
}
